<span class="search-tooltip" (mouseenter)="toggle(true)" (mouseleave)="toggle(false)">
  <div *ngIf="toolinfo">
    <span class="info-icon">
      <lucide-icon [size]="16" name="info"></lucide-icon>
    </span>
    <span class="tooltip-box" *ngIf="showinfo"> {{ toolinfo }} </span>
  </div>
  <div *ngIf="!toolinfo">
    <ng-content select="[tooltip-trigger]"></ng-content>
    <div class="tooltip-box-breadcrumb" *ngIf="showinfo">
      <ng-content></ng-content>
    </div>
  </div>
</span>
